import { motion } from 'framer-motion';

export default function Contact() {
  return (
    <section
      id="contact"
      className="min-h-screen w-full bg-secondary flex items-center justify-center py-24 px-6"
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1 }}
        className="backdrop-blur-xl bg-white/10 border border-white/20 rounded-3xl shadow-2xl p-10 md:p-16 flex flex-col md:flex-row items-center gap-12 max-w-6xl w-full"
      >
        {/* Image */}
        <motion.div
          initial={{ x: 50, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 1 }}
          className="relative w-full md:w-1/2 flex justify-center"
        >
          <img
            src="https://cdn-icons-png.flaticon.com/512/561/561127.png" // You can replace this with your own illustration
            alt="Contact Illustration"
            className="rounded-[2rem] max-w-[300px] w-full transform transition-transform duration-300 hover:scale-105"
          />
          <div className="absolute top-0 left-0 w-full h-full rounded-[2rem] bg-pink-500/10 blur-xl opacity-20 -z-10" />
        </motion.div>

        {/* Contact Form */}
        <motion.div
          initial={{ x: -50, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 1 }}
          className="w-full md:w-1/2 text-white"
        >
          <h2 className="text-4xl md:text-5xl font-extrabold mb-6 bg-gradient-to-r from-pink-400 via-fuchsia-400 to-purple-400 bg-clip-text text-transparent w-fit">
            Contact Me
          </h2>

          <form
            action="https://formspree.io/f/your-form-id" // Replace with your Formspree/EmailJS endpoint
            method="POST"
            className="flex flex-col gap-5"
          >
            <input
              type="text"
              name="name"
              required
              placeholder="Your Name"
              className="bg-white/10 text-white placeholder-white/70 rounded-xl px-5 py-3 focus:outline-none focus:ring-2 focus:ring-pink-500 transition"
            />

            <input
              type="email"
              name="email"
              required
              placeholder="Your Email"
              className="bg-white/10 text-white placeholder-white/70 rounded-xl px-5 py-3 focus:outline-none focus:ring-2 focus:ring-pink-500 transition"
            />

            <textarea
              name="message"
              required
              rows="4"
              placeholder="Your Message"
              className="bg-white/10 text-white placeholder-white/70 rounded-xl px-5 py-3 focus:outline-none focus:ring-2 focus:ring-pink-500 transition resize-none"
            ></textarea>

            <button
              type="submit"
              className="bg-gradient-to-r from-pink-400 via-fuchsia-400 to-purple-400 text-white font-bold py-3 px-6 rounded-xl hover:opacity-90 transition shadow-lg"
            >
              Send Message
            </button>
          </form>
        </motion.div>
      </motion.div>
    </section>
  );
}
